// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControls_BuildControl___6R4O","Label":"BuildControls_Label__5Urhm","Less":"BuildControls_Less__2GZdh","More":"BuildControls_More__lPddG"};